<template>
	<section
		id="toponymId"
		class="py-20 xl:pt-[120px] xl:pb-[60px] relative will-change"
		:data-scroll-section="inner == 'false'"
	>
		<div class="px-content mb-12">
			<h2 class="text-4xl xl:text-heading mb-8" v-show="blockData.title">
				{{ blockData.title }}
			</h2>
			<div
				class="xl:max-w-[40vw]"
				v-show="blockData.text"
				v-html="blockData.text"
			></div>
		</div>

		<!-- filter -->
		<div
			class="filter-wrap px-content flex items-center mb-10 w-full overflow-x-auto"
		>
			<button
				type="button"
				class="btn-filter whitespace-nowrap"
				@click="
					activeCategory = false;
					updateScroll();
				"
				:class="{ active: !activeCategory }"
			>
				{{ __("All destinations", "ccave") }}
			</button>
			<button
				type="button"
				class="btn-filter whitespace-nowrap"
				v-show="categories"
				v-for="cat in categories"
				:key="cat.id"
				@click="
					activeCategory = cat;
					updateScroll();
				"
				:class="{ active: activeCategory === cat }"
			>
				{{ cat.name }}
			</button>
		</div>

		<!-- card list -->
		<div
			class="px-content grid md:grid-cols-2 xl:grid-cols-3 gap-5 xl:gap-x-6 xl:gap-y-10"
		>
			<div
				class="card-toponyms bg-white"
				v-show="toponyms"
				v-for="(toponym, index) in filteredToponyms"
				:key="index"
			>
				<div class="overflow-hidden relative">
					<img
						class="object-cover w-full max-h-[270px] min-h-[270px]"
						v-if="toponym.data.fields.image"
						:src="toponym.data.fields.image.url"
						:alt="toponym.data.fields.image.alt"
					/>
				</div>
				<div
					class="card-toponyms__txt"
					:class="{
						'mt-10': !getToponymCategory(toponym.toponym_category[0]).data
							.fields.icon,
					}"
				>
					<div
						class="picto picto-toponyms mb-5 invisible"
						v-if="
							getToponymCategory(toponym.toponym_category[0]).data.fields.icon
						"
					>
						<img
							:src="
								getToponymCategory(toponym.toponym_category[0]).data.fields.icon
									.url
							"
							:alt="
								getToponymCategory(toponym.toponym_category[0]).data.fields.icon
									.alt
							"
						/>
					</div>
					<h4
						class="text-2xl tracking-[1px] mb-5"
						v-show="toponym.title.rendered"
					>
						{{ toponym.title.rendered }}
					</h4>
					<div
						class="line-clamp mb-8 text-sm"
						v-show="toponym.data.fields.text"
						v-html="toponym.data.fields.text"
					></div>
					<!-- <button type="button" class="uppercase tracking-little text-navy-blue-02 cursor-pointer mt-auto" @click="openModal(toponym);">VIEW MORE</button> -->
					<div
						:class="[
							'toponym-card-buttons flex align-center',
							toponym.content.rendered !== ''
								? 'justify-between'
								: 'justify-end',
						]"
					>
						<a
							v-if="toponym.content.rendered !== ''"
							class="uppercase text-xs tracking-little text-navy-blue-02 text-left mt-auto"
							:href="toponym.link"
						>
							{{ __("VIEW MORE", "ccave") }}
						</a>
						<button
							type="button"
							class="uppercase text-xs tracking-little self-end text-navy-blue-02 text-left mt-auto"
							@click.stop.prevent="showHideToponymCard(toponym)"
						>
							{{ __("QUICK OVERVIEW", "ccave") }}
						</button>
					</div>
				</div>
			</div>
		</div>
		<!-- ./card list -->

		<!-- Slide Toponym card -->
		<div
			:class="{
				'xyz-in z-[51] active-card': showToponymCard,
				'xyz-out  z-[40]': !showToponymCard,
			}"
			data-scroll
			data-scroll-sticky
			data-scroll-target="#toponymId"
			class="card-toponyms--slide fixed right-0 top-66px xl:top-[116px] bottom-0 z-[51] flex flex-col bg-white shadow-md w-full sm:w-[504px] h-[calc(100vh-66px)] xl:h-[calc(100vh-116px)] overflow-y-auto invisible scroll-just-this"
			xyz="fade right-100% duration-4"
			ref="toponymCard"
			v-on-clickaway="clickAwaySlide"
		>
			<button
				type="button"
				@click="showHideToponymCard()"
				class="grid place-items-center bg-mid-grey rounded-full cursor-pointer hover:opacity-70 w-10 h-10 absolute right-6 top-6"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					class="h-6 w-6"
					fill="none"
					viewBox="0 0 24 24"
					stroke="white"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="1"
						d="M6 18L18 6M6 6l12 12"
					/>
				</svg>
			</button>
			<div class="pb-10 h-full" v-if="activeToponym">
				<div class="overflow-hidden h-[34vh]">
					<img
						class="object-cover w-full"
						:src="activeToponym.data.fields.image.sizes.customslide"
						:alt="activeToponym.data.fields.image.alt"
					/>
				</div>
				<div class="p-8">
					<h4 class="text-2xl tracking-[1px] mb-6">
						{{ activeToponym.title.rendered }}
					</h4>
					<div class="text-sm" v-html="activeToponym.data.fields.text"></div>
				</div>
				<div
					v-show="activeToponym.data.fields.gallery"
					class="toponym-swiper swiper-container h-[25vh]"
					ref="sliderModal"
				>
					<div class="swiper-wrapper">
						<div
							v-for="(slide, index) in activeToponym.data.fields.gallery"
							:key="index"
							class="swiper-slide"
						>
							<img
								class="object-cover w-full h-full"
								:src="slide.sizes.toponymslide"
								:alt="slide.alt"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
// import ModalWindow from "@vuesence/modal-window";
import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";
import { mixin as clickaway } from "vue-clickaway";
export default {
	name: "ToponymsList",
	mixins: [clickaway],
	components: {
		// ModalWindow
	},
	data() {
		return {
			toponyms: false,
			categories: false,
			activeCategory: false,

			showModal: false,
			activeToponym: false,

			showToponymCard: false,

			// hasContent: false,

			/* MODAL SLIDER */
			sliderModal: null,
			sliderModalOptions: {
				slidesPerView: 2,
				spaceBetween: 16,
				// freeMode: true
			},
		};
	},
	mounted() {
		this.getToponyms();
		window.showHideToponymCard = this.showHideToponymCard;
	},
	watch: {
		showToponymCard: function (val) {
			if (val) {
				this.$root.scroll.stop();
			} else {
				this.$root.scroll.start();
			}
		},
	},
	computed: {
		filteredToponyms() {
			let results = this.toponyms;
			if (this.activeCategory) {
				results = results.filter(
					(toponym) => toponym.toponym_category[0] === this.activeCategory.id
				);
			}
			return results;
		},
	},
	methods: {
		clickAwaySlide() {
			this.showToponymCard = false;
		},
		getToponyms() {
			this.getToponymCategories();
			this.$http
				.get(this.endpoints.rest_base_endpoint + "wp/v2/toponym?per_page=100")
				.then((res) => {
					this.toponyms = res.data;
				});
		},
		getToponymCategories() {
			this.$http
				.get(this.endpoints.rest_base_endpoint + "wp/v2/toponym_category")
				.then((res) => {
					this.categories = res.data;
				});
		},
		// relatedToponym(toponym){
		//     this.activeToponym = toponym
		//     this.showModal = true
		//     this.$nextTick( ()=>{ this.sliderModal = new Swiper( this.$refs.sliderModal, this.sliderModalOptions ) } )
		// },
		showHideToponymCard(toponym) {
			if (
				this.$refs.toponymCard.classList.contains("invisible") &&
				!this.showToponymCard
			) {
				this.$refs.toponymCard.style.visibility = "visible";
				this.activeToponym = toponym;
				this.showToponymCard = true;

				this.$nextTick(() => {
					this.sliderModal = new Swiper(
						this.$refs.sliderModal,
						this.sliderModalOptions
					);
				});
			} else {
				setTimeout(() => {
					this.$refs.toponymCard.style.visibility = "hidden";
				}, 500);
				this.showToponymCard = false;
			}
		},
		// toponymHasContent(toponym) {
		// 	if (toponym && toponym.content && toponym.rendered.trim().length > 0) {
		// 		this.hasContent = true;
		// 	}
		// },
		getToponymCategory(categoryId) {
			let results = [];
			if (this.filteredToponyms.length > 0) {
				results = this.categories.find((c) => c.id === categoryId);
			}
			return results;
		},
	},
};
</script>
